import "./home.css";

import * as routes from "../constants/routes";

import { Link, withRouter } from "react-router-dom";
import React, { Component } from "react";

import Api from "../services/api";
import AuthService from "../services/auth";
import FullWidthInfo from "../components/FullWidthInfo";
import GoogleAd from "react-google-ad";
import Modal from "react-modal";
import MyProfile from "../components/MyProfile";
import ProfileList from "../components/ProfileList";
import checkCircle from "../static/vectors/check-circle.svg";
import { compose } from "recompose";
import { connect } from "react-redux";
import withAuth from "../components/withAuth";

//import { db } from '../firebase';

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      modalMessage: ""
    };
  }

  componentDidMount() {
    const { setCurrentPage } = this.props;
    if (!AuthService.isLoggedIn()) {
      this.props.history.push(routes.LOGIN);
    }
    setCurrentPage(routes.HOME);
  }

  startTrialSuperior() {
    new Api()
      .post("/startPromoSuperior", {}, AuthService.getAuthCookie())
      .then(response => {
        this.setState(
          {
            isModalOpen: true,
            modalMessage: response.message
          },
          () => {
            this.refreshCurrentUser();
          }
        );
      });
  }

  closeModal() {
    this.setState(
      {
        isModalOpen: false,
        modalMessage: ""
      },
      () => {
        window.location = window.location;
      }
    );
  }

  refreshCurrentUser() {
    const { authUser, onSetAuthUser } = this.props;
    new Api()
      .get("/users/current", {}, AuthService.getAuthCookie())
      .then(response => {
        onSetAuthUser(authUser, response.user);
      });
  }

  render() {
    const { ucdUser } = this.props;
    const { isModalOpen, modalMessage } = this.state;
    let message =
      ucdUser && ucdUser.status < 2
        ? `Your profile is waiting for approval, be sure you have uploaded a nice appropriate profile image. Also view our <a href='https://upperclassdates.com/photo-guidelines/' target='_blank' rel='noopener noreferrer'>photo guidelines</a>`
        : "*** These are some recently activated profiles ***";
    return (
      <div className="container home">
        {AuthService.isLoggedIn() && (
          <div className="row">
            <div className="col order-2 order-md-1 col-12 col-md-8 list">
              <FullWidthInfo
                gutters={true}
                dangerouslySetInnerHTML={{ __html: message }}
              />
              <ProfileList />
            </div>
            <div className="col order-1 order-md-2 col-12 col-md-4 profile">
              <MyProfile />
              {ucdUser && ucdUser.accountType === "sugar_baby" && (
                <div className="banner">
                  <p className="bold center">Personal PROMOCODE</p>
                  <p className="center">
                    Earn up to &#36;50 per date! let your sugar daddy use your
                    promocode for dating
                  </p>
                  <div className="btn no-pointer">{ucdUser.refCode}</div>
                </div>
              )}
              {ucdUser &&
                ucdUser.accountType === "sugar_parent" &&
                !!ucdUser.usedTrialSuperior &&
                ucdUser.status >= 2 && (
                  <div className="banner">
                    {ucdUser.status === 3 && (
                      <p className="bold center">ELITE MEMBERSHIP</p>
                    )}
                    {ucdUser.status === 2 && (
                      <p className="bold center">SUPERIOR MEMBERSHIP</p>
                    )}
                    {ucdUser.status === 3 && (
                      <p className="center">
                        HAVE A SUCCESSFUL DATE
                        <br />
                        WITH YOUR FAVOURITE HOST
                      </p>
                    )}
                    {ucdUser.status === 2 && (
                      <p className="center">
                        BUY ONE GET, ONE FREE
                        <br />
                        YOU HAVE BEEN SELECTED – GET AN EXTRA FREE MONTH
                        SUPERIOR!
                      </p>
                    )}
                    {ucdUser.status === 2 && (
                      <Link className="btn" to={"/promo-upgrade"}>
                        CONFIRM IT NOW!
                      </Link>
                    )}
                    {ucdUser.status === 3 && (
                      <Link className="btn" to={"/upgrade/#elite-membership"}>
                        CONFIRM YOUR DATE!
                      </Link>
                    )}
                  </div>
                )}
              {ucdUser && ucdUser.status <= 3 && (
                <div className="d-md-block ad-container">
                  <GoogleAd
                    client="ca-pub-2888386750549640"
                    slot="5113430388"
                    format="auto"
                  />
                </div>
              )}
            </div>
          </div>
        )}
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => {
            this.closeModal();
          }}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={{
            content: {
              top: "50%",
              bottom: "auto",
              left: "50%",
              right: "auto",
              transform: "translate(-50%, -50%)"
            }
          }}
        >
          <div className="content text-center">
            <img src={checkCircle} alt="check" />
            <div className="message">{modalMessage}</div>
            <button
              onClick={() => {
                this.closeModal();
              }}
            >
              {" "}
              Close X
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  ...props,
  ucdUser: state.sessionState.ucdUser
});

const mapDispatchToProps = dispatch => ({
  onSetAuthUser: (authUser, ucdUser) =>
    dispatch({ type: "AUTH_USER_SET", authUser, ucdUser }),
  setCurrentPage: page => dispatch({ type: "SET_CURRENT_PAGE", page })
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withAuth,
  withRouter
)(HomePage);



// WEBPACK FOOTER //
// ./src/pages/home.js